(function($) {
    var defaults = {
        success: function() {},
        error: function() {}
    };

    /**
     * Превращение формы в отправляемую аяксом с отображением ошибок конкретных полей
     *
     * У форм обязательно должен быть прописан атрибут action!
     * В ответ должен прийти json объект с полями status и data
     * Поле status должно содержать "success", иначе считаем, что ошибка.
     * В случае ошибки в data должен быть объект, у которого ключи - айдишники элементов формы,
     * а значения - массивы с текстами ошибок (у поле может быть более одной ошибки).
     * Ошибки прицепляются сразу после поля внутри элемента <div class="alert alert-danger" />
     * В форме желательно иметь элемент с классом form-ajax-result, куда будет выводиться
     * результат успешной отправки формы и лоадер во время запроса.
     * @todo сделать все более универсально
     *
     * @param {object} options
     */
    $.fn.symfonyAjaxForm = function(options) {
        var settings = $.extend({}, defaults, options);
        var $form = this.eq(0); // todo: сделать обработку множества форм через .each()
        var $formResult = $form.find(".form-ajax-result");

        $form.on("submit", function(e) {
            e.preventDefault();
            $lastErrors.remove();
            $formResult.html("<i class='fa fa-spinner fa-pulse fa-2x'></i>");
            $.ajax({
                type: "post",
                url: $form.attr("action"),
                data: $form.serialize(),
                success: function(result) {
                    var additional = result.additional ? result.additional : null;
                    if (result.status === "success") {
                        $formResult.html("<div class='modal-alert'>" + result.data + "</div>");
                        settings.success(result.data, additional);
                    } else {
                        $formResult.empty();
                        showErrors(result.data);
                        settings.error(result.data, additional);
                    }
                },
                error: function() {
                    $formResult.html("<div class='alert alert-danger'>Во время отправки произошла ошибка</div>");
                }
            });
        });

        var $lastErrors = $();
        function showErrors(errors) {
            $lastErrors = $();
            for (var id in errors) {
                if (errors.hasOwnProperty(id)) {
                    var message = errors[id].join(", ");
                    var $error = $("<div class='alert alert-danger'>" + message + "</div>");
                    $error.insertAfter($form.find("#" + id));
                    $lastErrors = $lastErrors.add($error);
                }
            }
        }

        return this;
    };
})(jQuery);
